<div
  class="mb-6 border-b border-gray-200 pb-4 flex flex-col md:flex-row md:items-center md:gap-6"
  [formGroup]="attachment"
>
  <div class="flex-1 mb-2 md:mb-0">
    <div class="text-sm text-gray-500 mb-1">Attachment Name</div>
    <mat-form-field appearance="fill" class="w-full">
      <input matInput formControlName="attachmentName" placeholder="Attachment Name" />
    </mat-form-field>
  </div>
  <div class="flex-1 mb-2 md:mb-0">
    <div class="text-sm text-gray-500 mb-1">Document</div>
    <mat-form-field appearance="fill" class="w-full not-allowed">
      <input
        [style.cursor]="'not-allowed'"
        matInput
        formControlName="attachmentDocument"
        placeholder="Document"
        readonly
      />
    </mat-form-field>
  </div>
  <div class="flex flex-row gap-2 items-end mb-2 md:mb-0">
    <button
      mat-flat-button
      color="primary"
      type="button"
      (click)="triggerFileInput()"
      [disabled]="attachment.get('isUploading')?.value"
    >
      <ng-container *ngIf="attachment.get('isUploading')?.value; else browseText">
        <mat-spinner diameter="20" class="inline-block align-middle"></mat-spinner>
      </ng-container>
      <ng-template #browseText>BROWSE</ng-template>
    </button>
    <input type="file" class="hidden" id="fileInput" (change)="onFileSelected($event)" />
    <button
      mat-flat-button
      color="accent"
      type="button"
      (click)="viewAttachment()"
      [disabled]="attachment.get('isUploading')?.value"
    >
      VIEW
    </button>
    <div *ngIf="attachment.get('uploadError')?.value" class="text-red-600 text-xs mt-2 ml-1">
      {{ attachment.get('uploadError')?.value }}
    </div>
  </div>
</div>
